// extracted by mini-css-extract-plugin
export default {"clip_to_board":"ShareInfoPopup_clip_to_board__cxO33"};